module.exports = __webpack_public_path__ + "img/logo.fb8100ac.png";